<template>
    <Dialog v-model:visible="visibleLocal" modal header="Scheduling Conflicts Detected" :style="{ width: '50rem' }"
        :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">

        <div class="p-4 bg-yellow-50 border-round-lg mb-4 text-orange-800">
            <i class="pi pi-exclamation-triangle mr-2"></i>
            The following existing classes overlap with the new schedule you are attempting to create:
        </div>

        <div v-if="props.data && props.data.length > 0">
            <div v-for="(conflict, index) in props.data" :key="index"
                 class="p-4 mb-4 border-1 border-gray-300 border-round-md">

                <h5 class="text-lg font-semibold mb-3 text-primary">Conflict {{ index + 1 }}</h5>
                
                <div class="grid p-fluid">
                    
                    <div class="col-12 md:col-6">
                        <h6 class="text-base font-medium mb-2 text-600">Existing Class</h6>
                        <div class="surface-ground p-3 border-round">
                            <ul class="list-none p-0 m-0 text-sm">
                                <li class="flex align-items-center mb-1">
                                    <i class="pi pi-calendar mr-2 text-primary"></i>
                                    <strong>Date:</strong> <span class="ml-2">{{ conflict.date }}</span>
                                </li>
                                <li class="flex align-items-center mb-1">
                                    <i class="pi pi-clock mr-2 text-primary"></i>
                                    <strong>Time:</strong> <span class="ml-2">{{ conflict.existingStart }} - {{ conflict.existingEnd }}</span>
                                </li>
                                <li class="flex align-items-center mb-1">
                                    <i class="pi pi-user mr-2 text-primary"></i>
                                    <strong>Tutor:</strong> <span class="ml-2">{{ conflict.existingTutor }}</span>
                                </li>
                                <li class="flex align-items-center">
                                    <i class="pi pi-book mr-2 text-primary"></i>
                                    <strong>Subject:</strong> <span class="ml-2">{{ conflict.existingSubject }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="col-12 md:col-6">
                        <h6 class="text-base font-medium mb-2 text-600">New Schedule Overlap</h6>
                        <div class="surface-ground p-3 border-round">
                             <ul class="list-none p-0 m-0 text-sm">
                                <li class="flex align-items-center mb-1">
                                    <i class="pi pi-calendar-plus mr-2 text-red-500"></i>
                                    <strong>New Date:</strong> <span class="ml-2">{{ conflict.date }}</span>
                                </li>
                                <li class="flex align-items-center">
                                    <i class="pi pi-clock mr-2 text-red-500"></i>
                                    <strong>New Time:</strong> <span class="ml-2">{{ conflict.newStart }} - {{ conflict.newEnd }}</span>
                                </li>
                            </ul>
                            </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div v-else class="text-center text-500 p-5">
            <i class="pi pi-check-circle text-green-500 text-3xl mb-3"></i>
            <p>No conflict data was provided.</p>
        </div>

    </Dialog>
</template>

<script setup>
import Dialog from 'primevue/dialog';
import { defineProps, defineEmits, computed } from 'vue';

const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true,
        default: false
    },
    data: {
        type: Array,
        default: () => [] 
    }
})

const emit = defineEmits(['update:modelValue']);

const visibleLocal = computed({
    get() {
        return props.modelValue;
    },
    set(newValue) {
        emit('update:modelValue', newValue);
    }
});
</script>